function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#dollar_svg__clip0_956_88)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.684 10.49a3.864 3.864 0 011.223-7.531h2.785m0 0h2.217a4.433 4.433 0 014.433 4.433m-6.65-4.433V.742m0 2.217v14.408m-6.65-1.108a4.433 4.433 0 004.433 4.433h5.002a3.865 3.865 0 001.223-7.53l-4.008-1.337",
  stroke: "#fff",
  strokeWidth: 2.078,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "dollar_svg__clip0_956_88"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h23.385v23.385H0z"
})));

var SvgDollar = function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgDollar;